<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:58:40
 * @Description: 查看维保合同
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="查看合同"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="120px"
        label-suffix="："
      >
        <!-- 基本信息 -->
        <el-row
          class="c-form__row"
        >
          <!-- <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            维保基本信息
          </el-col> -->
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="客户名称"
              prop="khmc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.khmc || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="合同编号"
              prop="deptName"
            >
              <span
                class="c-form__read"
              >
                {{ fd.htbh || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="合同名称"
              prop="htmc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.htmc || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="合同金额（元）"
              prop="htje"
            >
              <span
                class="c-form__read"
              >
                {{ fd.htje || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="合同有效期"
              prop="yxq"
            >
              <span
                class="c-form__read"
              >
                {{ fd.yxqq | date("yyyy-MM-dd ") }}  至 {{ fd.yxqz | date("yyyy-MM-dd ") }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="录入单位"
              prop="lrdw"
            >
              <span
                class="c-form__read"
              >
                {{ fd.lrdw || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="创建时间"
              prop="createTime"
            >
              <span
                class="c-form__read"
              >
                {{ fd.createTime | date('yyyy-MM-dd HH:mm') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="最后修改时间"
              prop="updateTime"
            >
              <span
                class="c-form__read"
              >
                {{ fd.updateTime | date('yyyy-MM-dd HH:mm') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="khmc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.xmmc || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          />
        </el-row>
        <template>
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            合同附件
          </el-col>
          <el-table
            ref="listTable"
            class="c-page__table o-header-text-center"
            stripe
            border
            highlight-current-row
            tooltip-effect="dark"
            :data="tableData.rows"
            :class="{ 'o-table-empty-center': tableData.rows.length <= 0 }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="40"
              align="center"
            />
            <el-table-column
              prop="name"
              label="合同附件"
              min-width="180"
            >
              <template slot-scope="scope">
                <span
                  class="c-form__read"
                >
                  {{ scope.row.fileName || '-' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="yxq"
              label="有效期"
              min-width="180"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.yxqq | date("yyyy-MM-dd ") }}  至 {{ scope.row.yxqz | date("yyyy-MM-dd ") }}
              </template>
            </el-table-column>
            <el-table-column
              prop="htje"
              label="合同金额（元）"
              min-width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.htje }}
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wbhtManageService } from './wbht.service.js';
export default {
  name: 'ContractDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      tableData: {
        rows: []
      },
      /* 表单参数 Start */

      // actionUrl: `${ctxPrefix}${iffApi}/wbht/upload`,
      /* 表单参数 Start */
      fd: {
        id: null,
        khmc: null, // 客户名称
        htmc: null, // 合同名称
        htbh: null,
        htje: null,
        yxq: null, // 有效期
        htwj: null
      },

      /* 表单校验规则 End */
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'htfj', slotName: 'htfj', label: '合同附件', align: 'left', minWidth: '120', type: 'text' },
        { key: 'yxq', slotName: 'yxq', label: '合同名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'htje', slotName: 'yxq', label: '合同金额', align: 'center', minWidth: '220', type: 'text' }

      ]
      /* 表格列配置End */

    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 初始化数据
     */
    init () {
      wbhtManageService.getDetail(this.fd.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        });
      this.getFileInfo();
    },
    /**
     * 获取合同附件信息
     */
    getFileInfo () {
      wbhtManageService.getFileInfo(this.fd.id)
        .then(rsp => {
          this.tableData = Object.assign({}, this.tableData, rsp.data);
        });
    }
  },
  created () {
    // this.$nextTick(() => {
    this.fd.id = this.dlParams.id;
    this.init();
    // });
    //
  }
};

</script>
